import React, {useMemo, useState} from "react";
import useTranslation from "../../../../Hooks/useTranslation";
import LinkButton from "../../../../Components/Button/LinkButton";
import {Theme} from "../../../../Enums/Theme.enum";
import MediaViewerModal from "../../../../Components/MediaViewer/MediaViewerModal";
import {useAppContext} from "../../../../Services/AppContext";

interface Props {
    item: {
        id: string;
        type: string;
        document: {
            id: string;
            title: {
                extra: {
                    text: string;
                }
            };
        };
    };
}

const EcardFileViewerButton: React.FC<Props> = ({item}) => {
    const [isMediaViewerOpened, setIsMediaViewerOpened] = useState(false);
    const {t} = useTranslation();
    const {socketUrl} = useAppContext();

    if(!item.document){
        return null
    }

    const itemName = useMemo(() => {
        let name;

        if (item?.document?.title.extra) {
            return item.document.title.extra?.text
        }

        switch (item.type) {
            case 'medicalReportPatient':
                name = 'base.shared.medicalReport';
                break;
            case 'medicalReport':
                name = 'base.shared.medicalExamination';
                break;
            case 'prescription':
                name = 'base.ePrescription';
                break;
            case 'appointment':
                name = 'base.appointment';
                break;
        }
        return t(name);

    }, [item]);

    const fileToViewer = {
        id: item.document.id,
        displayName: itemName ?? '',
        type: 'pdf',
        preview: socketUrl + '/document/' + item.document.id + '/pdf/download',
        download: socketUrl + '/document/' + item.document.id + '/pdf/download',
    };

    return (
        <>
            <LinkButton title={itemName ?? ''} theme={Theme.BLUE} onClick={() => setIsMediaViewerOpened(true)}/>
            <MediaViewerModal
                opened={isMediaViewerOpened}
                onClose={() => setIsMediaViewerOpened(false)}
                file={fileToViewer}
            />
        </>
    )
}

export default EcardFileViewerButton;